import React, { Fragment } from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'
import { styles } from './styles'
import { Grid } from '@material-ui/core'
import SubmitButton from '../../../../../Components/Form/Button'
import { BLOCKS, INITIAL_DATA, TYPES } from '../Container/options'
import {
  CAMPAIGN_INTERNAL_STATUSES,
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_SUBTYPES_ENUM,
} from '../../../../../shared/constants'

const filterDownloadItems = (key, campaign) => {
  const { type: campaignType, subtype } = campaign

  // Filter items for INSERTS campaigns
  if (campaignType === CAMPAIGN_ENUM_TYPES.INSERTS) {
    return [
      TYPES.DOWNLOAD_FLYER_DESIGN,
      TYPES.DOWNLOAD_PRINTING_SUMMARY,
      TYPES.DOWNLOAD_ALL,
    ].includes(key)
  }

  // Show DOWNLOAD_AUDIENCE_FLYER only for ADM campaigns
  if (key === TYPES.DOWNLOAD_AUDIENCE_FLYER) {
    return subtype !== CAMPAIGN_SUBTYPES_ENUM.ADM
  }

  return false
}

const InternalFilesView = ({ classes, buttonsActions, campaign }) => {
  return (
    <Grid container xs={12} className={classes.wrapper}>
      <Grid item xs={7} className={classes.blockLeft}>
        {INITIAL_DATA[BLOCKS.LEFT].map(({ title, items }) => (
          <Fragment>
            <div className={classes.title}>{title}</div>
            <div className={classes.uploadItemsWrapper}>
              {Object.entries(items).map(
                ([key, { title, subTitle, buttons }]) => {
                  const buttonsInfo = buttonsActions[key]

                  const error =
                    key === TYPES.DIGITAL_PROOF_FROM_PRINTER &&
                    !!campaign.createdAt &&
                    campaign.internalStatus !==
                      CAMPAIGN_INTERNAL_STATUSES.GENERATING_DIGITAL_PROOF &&
                    !campaign.contracts[TYPES.DIGITAL_PROOF_FROM_PRINTER]

                  return (
                    <div
                      className={classnames(classes.uploadWrapper, {
                        [classes.success]: buttonsInfo.success,
                      })}
                      key={key}
                    >
                      <div className={classes.description}>
                        <div className={classes.uploadTitle}>{title}</div>
                        <div className={classes.uploadSubtitle}>{subTitle}</div>
                        {error ? (
                          <span className={classes.error}>
                            Upload digital proof when this campaign will be in
                            the GENERATING DIGITAL PROOF stage.
                          </span>
                        ) : null}
                      </div>
                      <div className={classes.buttonWrapper}>
                        {buttons.map(button => {
                          const { label, disabled, onClick } = buttonsInfo[
                            button
                          ]
                          return (
                            <SubmitButton
                              key={label}
                              variant="contained"
                              onClick={onClick}
                              className={classes.button}
                              value={label}
                              disabled={disabled}
                            />
                          )
                        })}
                      </div>
                    </div>
                  )
                },
              )}
            </div>
          </Fragment>
        ))}
      </Grid>
      <Grid item xs={5} className={classes.blockRight}>
        {INITIAL_DATA[BLOCKS.RIGHT].map(({ title, items }) => (
          <Fragment>
            <div className={classes.title}>{title}</div>
            <div className={classes.uploadItemsWrapper}>
              {Object.entries(items)
                .filter(([key]) => !filterDownloadItems(key, campaign))
                .map(([key, { title, subTitle, buttons, off }]) => {
                  const buttonsInfo = buttonsActions[key]

                  if (!buttonsInfo) {
                    return null
                  }

                  return (
                    <div
                      key={key}
                      className={classnames(classes.uploadWrapper, {
                        [classes.off]: buttonsInfo ? buttonsInfo.off : false,
                      })}
                    >
                      <div className={classes.description}>
                        <div className={classes.uploadTitle}>{title}</div>
                        <div className={classes.uploadSubtitle}>{subTitle}</div>
                      </div>
                      <div className={classes.buttonWrapper}>
                        {buttons.map(button => {
                          const { label, disabled, onClick } = buttonsInfo[
                            button
                          ]
                          return (
                            <SubmitButton
                              key={label}
                              variant="contained"
                              onClick={onClick}
                              className={classes.button}
                              value={label}
                              disabled={disabled}
                            />
                          )
                        })}
                      </div>
                    </div>
                  )
                })}
            </div>
          </Fragment>
        ))}
      </Grid>
    </Grid>
  )
}

export default injectStyles(styles)(InternalFilesView)
